/* ============================================================================
   custom-design-popup.js
   ============================================================================ */

(function () {
  "use strict";

  /* ==========================================================================
     TEAM EDIT AREA — edit only these 4 sections.
     ========================================================================== */
  var CONFIG = {

    /* 1) WhatsApp and phone number (digits only for WA, "+" ok for tel) */
    WA_NUMBER: "919964080800",
    PHONE_TEL: "+919964080800",

    /* 2) Heading text */
    TITLE_LIGHT: "Need Help ",
    TITLE_BOLD:  "Customising?",

    /* 3) Product options shown as chips (label is also what's sent) */
    PRODUCTS: ["Sofa", "Arm Chair", "Sofa bed", "Bed Cot", "Recliner", "Others"],

    /* 4) Header icon asset URL from theme.liquid */
    ICON_URL: (window.POPUP_ICON_URL || ""),

    /* ======================= END OF TEAM EDIT AREA ======================= */

    MIN_NAME_LENGTH: 2,
    POPUP_DELAY_MS: 7000,
    CLOSE_LOCK_SECONDS: 5,
    ERR_NAME:    "Please enter your name.",
    ERR_PRODUCT: "Please select at least one option.",
    TRACKING_PARAMS: [
      "utm_source", "utm_medium", "utm_campaign",
      "utm_content", "utm_term", "gclid", "fbclid"
    ],
    STORAGE_KEY: "bs_design_popup_shown",
    COOKIE_DAYS: 365   // how long the "already shown" flag should persist via cookie
  };

  /* ==========================================================================
     STORAGE HELPERS — localStorage + cookie fallback, never throw.
     Using both means the "shown" flag survives even if one is blocked/cleared,
     e.g. Safari ITP clearing localStorage, or some in-app browsers restricting it.
     ========================================================================== */
  function lsGet(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }

  function cookieGet(name) {
    try {
      var match = document.cookie.match(
        new RegExp("(?:^|; )" + name.replace(/([.$?*|{}()[\]\\/+^])/g, "\\$1") + "=([^;]*)")
      );
      return match ? decodeURIComponent(match[1]) : null;
    } catch (e) { return null; }
  }
  function cookieSet(name, value, days) {
    try {
      var expires = "";
      if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + encodeURIComponent(value) + expires + "; path=/; SameSite=Lax";
    } catch (e) {}
  }

  // A visitor is "returning" if EITHER storage method says so.
  function hasAlreadySeenPopup() {
    return lsGet(CONFIG.STORAGE_KEY) === "1" || cookieGet(CONFIG.STORAGE_KEY) === "1";
  }
  // Mark as shown in BOTH places, so losing one doesn't reset the flag.
  function markPopupShown() {
    lsSet(CONFIG.STORAGE_KEY, "1");
    cookieSet(CONFIG.STORAGE_KEY, "1", CONFIG.COOKIE_DAYS);
  }


  /* ==========================================================================
     INLINE SVG ICONS (no external libraries)
     ========================================================================== */
  var WHATSAPP_SVG =
    '<svg width="19" height="19" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path fill="currentColor" d="M20.52 3.449C12.831-3.984.106 1.407.101 11.893c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652a11.882 11.882 0 005.667 1.443h.005c10.473 0 15.91-12.668 8.512-20.341zM12.012 21.785h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.002-8.793 10.744-13.19 16.957-6.976 6.203 6.15 1.847 16.866-7.07 16.866z"/>' +
      '<path fill="#4CAE4E" d="M8.17 6.52c.2-.45.4-.46.59-.47h.5c.17 0 .44.06.67.32.23.26.88.86.88 2.1s-.9 2.44-1.03 2.61c-.13.17-.19.28-.06.54.13.26.56.92 1.2 1.49.83.74 1.52.97 1.78 1.1.26.13.41.11.56-.07.15-.17.65-.75.82-1.01.17-.26.35-.22.59-.13.24.09 1.53.72 1.8.85.26.13.44.2.5.3.07.11.07.62-.15 1.21-.22.59-1.28 1.13-1.78 1.2-.45.07-1.02.1-1.65-.1-.38-.12-.87-.28-1.5-.56-2.63-1.14-4.35-3.81-4.48-3.98-.13-.17-1.08-1.44-1.08-2.75s.68-1.95.93-2.22c.24-.26.53-.33.71-.33z"/>' +
    '</svg>';

  var EXPERT_SVG =
    '<svg width="19" height="19" viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M5 11a7 7 0 0114 0" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
      '<rect x="3.4" y="10.4" width="3.1" height="5" rx="1.55" fill="currentColor"/>' +
      '<rect x="17.5" y="10.4" width="3.1" height="5" rx="1.55" fill="currentColor"/>' +
      '<path d="M18.8 15.2c0 2.6-2.1 4.1-4.5 4.3" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>' +
      '<circle cx="12" cy="9.2" r="2.8" fill="currentColor"/>' +
      '<path d="M7 21c0-3 2.4-5 5-5s5 2 5 5" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>' +
    '</svg>';


  /* ==========================================================================
     BUILD + RUN
     ========================================================================== */
  function initDesignPopup() {
    // Only show once, ever, per browser — skip if we've already shown it before
    // (checked via localStorage OR cookie, so it's resilient to either being cleared).
    if (hasAlreadySeenPopup()) return;

    // Don't double-insert if this somehow runs twice on the same page.
    if (document.getElementById("bs-design-popup-overlay")) return;

    var closeLockSeconds = CONFIG.CLOSE_LOCK_SECONDS;

    // ---- build chip rows (3 per row) from CONFIG.PRODUCTS ------------------
    var chipsHtml = "";
    for (var i = 0; i < CONFIG.PRODUCTS.length; i += 3) {
      chipsHtml += '<div class="bs-chip-row">';
      for (var j = i; j < i + 3 && j < CONFIG.PRODUCTS.length; j++) {
        var p = CONFIG.PRODUCTS[j];
        chipsHtml +=
          '<button type="button" class="bs-product-chip" data-value="' + p + '">' +
            p +
          '</button>';
      }
      chipsHtml += '</div>';
    }

    // ---- popup markup (same IDs / classes as the working design) -----------
    var popup = document.createElement("div");
    popup.id = "bs-design-popup-overlay";
    popup.innerHTML =
      '<div id="bs-design-popup-card" role="dialog" aria-modal="true" aria-labelledby="bs-popup-title">' +

        '<div id="bs-popup-close-wrap">' +
          '<span id="bs-popup-countdown">' + closeLockSeconds + '</span>' +
          '<button id="bs-popup-close-btn" type="button" aria-label="Close popup">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true">' +
              '<line x1="5" y1="5" x2="19" y2="19"></line>' +
              '<line x1="19" y1="5" x2="5" y2="19"></line>' +
            '</svg>' +
          '</button>' +
        '</div>' +

        '<div id="bs-popup-header">' +
          '<div id="bs-popup-logo">' +
            '<img src="' + CONFIG.ICON_URL + '" alt="" aria-hidden="true">' +
          '</div>' +

          '<h2 id="bs-popup-title">' +
            '<span class="bs-title-light">' + CONFIG.TITLE_LIGHT + '</span>' +
            '<span class="bs-title-bold">' + CONFIG.TITLE_BOLD + '</span>' +
          '</h2>' +
        '</div>' +

        '<div class="bs-popup-field">' +
          '<input id="bs-popup-name" class="bs-popup-input" type="text" ' +
                 'placeholder="Your Name" autocomplete="name">' +
        '</div>' +

        '<div id="bs-product-options">' + chipsHtml + '</div>' +

        '<div id="bs-popup-error"></div>' +

        '<div id="bs-popup-cta">' +
          '<button id="bs-popup-submit" type="button" disabled>' +
            '<span>Request <strong>Design</strong> Help</span>' + WHATSAPP_SVG +
          '</button>' +
          '<a id="bs-popup-call" href="tel:' + CONFIG.PHONE_TEL + '">' +
            '<span>Talk To An <strong>Expert</strong></span>' + EXPERT_SVG +
          '</a>' +
        '</div>' +

      '</div>';

    document.body.appendChild(popup);

    // ---- refs -------------------------------------------------------------
    var overlay    = document.getElementById("bs-design-popup-overlay"),
        countdownEl= document.getElementById("bs-popup-countdown"),
        closeBtn   = document.getElementById("bs-popup-close-btn"),
        nameInput  = document.getElementById("bs-popup-name"),
        chips      = document.querySelectorAll(".bs-product-chip"),
        submitBtn  = document.getElementById("bs-popup-submit"),
        callBtn    = document.getElementById("bs-popup-call"),
        errorBox   = document.getElementById("bs-popup-error");

    var selectedProducts = [];
    var closeUnlocked = false;

    // ---- open / close -----------------------------------------------------
    function openPopup() {
      overlay.classList.add("bs-active");
      markPopupShown();   // never show again on this browser
      startCloseTimer();
    }

    function closePopup() {
      if (!closeUnlocked) return;                    // locked during countdown
      overlay.classList.remove("bs-active");
      // NOTE: the "shown" flag was already set when the popup opened,
      // so closing it (with or without submitting) won't bring it back.
    }

    function startCloseTimer() {
      var remaining = closeLockSeconds;
      countdownEl.textContent = String(remaining);
      countdownEl.style.display = "inline-flex";
      closeBtn.style.display = "none";
      closeUnlocked = false;

      var timer = setInterval(function () {
        remaining--;
        if (remaining > 0) {
          countdownEl.textContent = String(remaining);
        } else {
          clearInterval(timer);
          closeUnlocked = true;
          countdownEl.style.display = "none";
          closeBtn.style.display = "flex";
        }
      }, 1000);
    }

    // ---- close interactions (all blocked until unlocked) ------------------
    closeBtn.addEventListener("click", closePopup);

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay && closeUnlocked) closePopup();
    });

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && closeUnlocked) closePopup();
    });

    // ---- validation -------------------------------------------------------
    function showError(message) {
      errorBox.textContent = message;
      errorBox.classList.add("bs-show");
    }
    function clearError() {
      errorBox.textContent = "";
      errorBox.classList.remove("bs-show");
    }
    function validateForm() {
      clearError();
      var hasName = nameInput.value.trim().length >= CONFIG.MIN_NAME_LENGTH;
      var hasProduct = selectedProducts.length > 0;
      submitBtn.disabled = !(hasName && hasProduct);
      return hasName && hasProduct;
    }

    // ---- chip selection (multiple allowed) --------------------------------
    chips.forEach(function (chip) {
      chip.addEventListener("click", function () {
        var value = chip.getAttribute("data-value");
        if (chip.classList.contains("bs-selected")) {
          chip.classList.remove("bs-selected");
          selectedProducts = selectedProducts.filter(function (item) {
            return item !== value;
          });
        } else {
          chip.classList.add("bs-selected");
          selectedProducts.push(value);
        }
        validateForm();
      });
    });

    nameInput.addEventListener("input", validateForm);

    // ---- build the WhatsApp message (single encode on the final string) ----
    function buildWhatsappMessage(name, products, pageUrl) {
      var lines = [
        "Need help Customising?",
        "",
        "Your Name: " + name,
        "Selected: " + products,
        "Page: " + pageUrl
      ];

      // Append tracking ONLY for params actually present in the URL.
      try {
        var params = new URLSearchParams(window.location.search);
        var trackingLines = [];
        CONFIG.TRACKING_PARAMS.forEach(function (key) {
          var val = params.get(key);
          if (val) trackingLines.push(key + ": " + val);
        });
        if (trackingLines.length) {
          lines.push("");
          lines.push("Tracking:");
          lines = lines.concat(trackingLines);
        }
      } catch (e) { /* ignore tracking if URL parsing fails */ }

      return lines.join("\n");
    }

    // ---- REQUEST DESIGN HELP ----------------------------------------------
    function openWhatsappWithDetails() {
      if (!validateForm()) {
        if (nameInput.value.trim().length < CONFIG.MIN_NAME_LENGTH) {
          showError(CONFIG.ERR_NAME);
        } else if (selectedProducts.length === 0) {
          showError(CONFIG.ERR_PRODUCT);
        }
        return;
      }

      var name = nameInput.value.trim();
      var products = selectedProducts.join(", ");
      var pageUrl = window.location.href.split("#")[0];

      var message = buildWhatsappMessage(name, products, pageUrl);
      var waUrl = "https://wa.me/" + CONFIG.WA_NUMBER +
                  "?text=" + encodeURIComponent(message);

      window.open(waUrl, "_blank", "noopener");
      overlay.classList.remove("bs-active");
    }

    submitBtn.addEventListener("click", openWhatsappWithDetails);

    // ---- TALK TO AN EXPERT (the href just dials, nothing else to do here) --

    // initial state
    validateForm();

    // ---- open after the configured delay -----------------------------------
    setTimeout(openPopup, CONFIG.POPUP_DELAY_MS);
  }


  /* ==========================================================================
     START — as soon as the DOM is ready; also handles scripts loaded after readiness.
     ========================================================================== */
  function onDomReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
    } else {
      callback();
    }
  }

  onDomReady(initDesignPopup);

})();